/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import styled from "styled-components";

import {WealthyEnv} from "helpers";

const avendusImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-avendus.webp`;
const dspImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-dsp.webp`;
const hdfcLifeImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-hdfc.webp`;
const mahindraImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-mahindra.webp`;
const tataAiaImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-tata.webp`;
const iciciImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-icici.webp`;
const idfcImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-idfc.webp`;
const lAndTMf = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-l&t.webp`;
const invescoImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-invesco.webp`;
const kotakImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-kotak.webp`;

const partnerImages = [
  avendusImage,
  dspImage,
  hdfcLifeImage,
  mahindraImage,
  tataAiaImage,
  iciciImage,
  idfcImage,
  lAndTMf,
  kotakImage,
  invescoImage
];

const datum = [
  {
    titleOne: "Build your business",
    titleTwo: "Leverage our technology",
    description: "We understand and appreciate the effort it takes to build relationships, especially when it comes to advising on financial and wealth needs. Our technology through our Partner App, automated dashboards, quick access to products, allows you to focus on what matters the most - building your clients wealth",
    footerDescription: "Do business, anywhere, anytime",
    illustrationImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-build-your-business.webp`
  },
  {
    titleOne: "Grow your knowledge",
    titleTwo: "as you grow your business",
    description: "Our best-in class training program and support through our teams from Day 1 allow your push your potential and your profession to the fullest. Whether you want support on product details or any other advice on new investments in the market, our team of professionals are there to guide you - so you can focus on growing your practice",
    footerDescription: "Live trainings on products and sales skills",
    illustrationImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-product-partners-grow-your-knowledge.webp`
  }
];

const ProductPartners = () => {
  const data = datum.map((eachData, index) => {
    return (
      <ContentImageWrapper className={`${index === 1 ? "add-margin" : ""}`}>
        <Content>
          <ContentTitle>
            {eachData.titleOne}<br />
            {eachData.titleTwo}
          </ContentTitle>
          <Description>{eachData.description}</Description>
          <FooterDescription>
            {eachData.footerDescription}
          </FooterDescription>
        </Content>
        <Image>
          <img alt="wealthy-benefits-image" className="content-image" loading="lazy" src={eachData.illustrationImage} />
        </Image>
      </ContentImageWrapper>
    );
  });

  return (
    <Wrapper id="our-partners">
      <Title>Our Product Partners</Title>
      <ImageWrapper>
        {partnerImages.map(partnerImage =>  <EachImage> <img alt="wealthy-product-partner-image" loading="lazy" src={partnerImage}  /></EachImage>)}
      </ImageWrapper>
      <ContentContainer>
        <Border />
        {data}
      </ContentContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 5rem 0 0;
`;

const Title = styled.h3`
  text-align: center;
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const ImageWrapper = styled.div`
  padding: 0;
  margin: 4rem auto 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 80%;

  @media (max-width: 768px) {
    width: 100%;
    margin: 4rem auto 0;
  }
`;

const EachImage = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  background: #fff;
  color: #000;
  background-color: #fff;
  border-radius: 4px;
  width: 18rem;
  height: 12rem;
  margin-left: 2rem;
  margin-right: 1rem;
  >img {
    object-fit: contain;
    width: 100%;
  }

  :hover {
    cursor: pointer;
  }

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,1);
    transition: none;
  }

  &:hover::after {
    width: 120%;
    background-color: rgba(255,255,255,0);
    transition: all 0.4s ease-in-out;
  }

  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;

const ContentContainer = styled.div`
  width: 75%;
  padding: 10rem 0;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Border = styled.div`
  border: 1px solid #e7e7e7;
  margin-bottom: 10rem;
  opacity: 0.5;
`;

const ContentImageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  &.add-margin {
    margin-top: 15rem;
    flex-direction: row-reverse;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding: 2rem;

    &.add-margin {
      margin-top: 8rem;
      flex-direction: column-reverse;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 3rem;
  }
`;

const ContentTitle = styled(Title)`
  font-size: 3.6rem;
  line-height: 1.62;
  text-align: left;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    line-height: 1.5;
    text-align: center;
  }
`;

const Description = styled.p`
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: left;
  color: #7e7e7e;
  margin: 2.4rem auto;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 1.5;
    text-align: center;
    padding: 0 2rem;
  }
`;

const Image = styled.div`
  width: 55rem;
  height: 40rem;
  border-radius: 2.4rem;
  .content-image {
    object-fit: contain;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 32rem;
    margin-bottom: 3rem;
  }
`;

const FooterDescription = styled.h3`
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    text-align: center;
  }
`;

export default ProductPartners;
